module.exports = __webpack_public_path__ + "img/hyper_llm.c631dbc8.png";